import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
function Footer(){
    return(
        <container className='footer'>
            <Row>
                <Col>
                    <p>© 2024 Web Strategic Solutions LLC</p>
                    <p>2108 N STREET, STE N. SACRAMENTO CA, 95816</p>
                </Col>
            </Row>
        </container>
    )
}

export default Footer;